<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  },
  mounted(){
  },
  methods:{
  }
}
</script>

<style>
  html,body,.app{
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
  }
  iframe{
    width: 100vw;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue